export default __webpack_public_path__ + "6c77e0debca977a54c9f56c222400cf6.png";